<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div :class="[formClass, { 'has-error': srvPasswordError }]">
            <div class="flex label-item">
                <label>New Password:</label>

                <Tooltip
                    :tooltip="passwordHelp"
                    v-if="passwordHelp.length > 0"
                ></Tooltip>
            </div>
            <input
                type="password"
                name="password"
                class="form-input"
                placeholder="Enter new password"
                v-model="password"
                autocomplete="nope"
                readonly
                ref="password"
                @focus="activate('password')"
            />
            <div class="text-error" v-if="srvPasswordError">{{ srvPasswordError }}</div>
        </div>
        <div :class="[formClass, { 'has-error': srvConfirmError }]">
            <div class="flex label-item">
                <label>Confirm Password:</label>

                <Tooltip
                    :tooltip="confirmHelp"
                    v-if="confirmHelp.length > 0"
                ></Tooltip>
            </div>
            <input
                type="password"
                name="password-confirm"
                class="form-input active-password"
                placeholder="Repeat new password"
                v-model="passwordConfirm"
                autocomplete="nope"
                readonly
                ref="password-confirm"
                @focus="activate('password-confirm')"
            />
            <div class="text-error" v-if="srvConfirmError">{{ srvConfirmError }}</div>
        </div>
        <div class="mt-2 text-xs space-y-2" v-if="activeValidation">
            <div v-for="(item, index) in errors" :value="index" v-if="!isValid">
                <div v-show="item.status" class="text-emerald-500">
                    <i class="fal fa-check mr-2"></i>{{ item.notice }}
                </div>
                <div v-show="!item.status" class="text-red-500">
                    <i class="fal fa-times mr-2"></i>{{ item.notice }}
                </div>
            </div>
            <div v-if="isValid">
                <div class="text-emerald-500">
                    <i class="fal fa-check mr-2"></i>The password meets all
                    requirements.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        password: "",
        passwordConfirm: "",

        activeValidation: false,
        errors: {
            minLength: {
                status: false,
                notice: "Minimum length is 10 characters",
            },
            lowercase: {
                status: false,
                notice: "Requires at least one lowercase letter",
            },
            uppercase: {
                status: false,
                notice: "Requires at least one uppercase letter",
            },
            number: {
                status: false,
                notice: "Requires at least one number",
            },
            character: {
                status: false,
                notice: "Requires at least one special character",
            },
            match: {
                status: false,
                notice: "Passwords must match",
            },
        },
        notice: "Your password must contain at least one of each of the following: lowercase character, uppercase character, number & special character eg, any one or more of these @$!%*#?&",
    };
}
import _find from "lodash/find";
export default {
    props: {
        required: {
            type: Number | String,
            required: false,
            default: false,
        },
        passwordHelp: {
            type: String,
            required: false,
            default: "",
        },
        confirmHelp: {
            type: String,
            required: false,
            default: "",
        },
        passwordError: {
            type: String,
            required: false,
            default: "",
        },
        confirmError: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            ...initialState(),
            // FCI-19: local copies of the server-side errors so they can be
            // cleared as soon as the user starts typing a valid value
            srvPasswordError: this.passwordError,
            srvConfirmError: this.confirmError,
        };
    },
    mounted() {},
    watch: {
        password(val) {
            // FCI-19: clear the server-side error once the user edits the field
            if (this.srvPasswordError) this.srvPasswordError = "";
            if (val.length > 0) {
                this.activeValidation = true;
                this.checkPassword();
            } else {
                this.activeValidation = false;
            }
        },
        passwordConfirm() {
            // FCI-19: clear the server-side error once the user edits the field
            if (this.srvConfirmError) this.srvConfirmError = "";
            if (this.activeValidation) this.checkPassword();
        },
    },
    methods: {
        checkPassword() {
            var errors = [];
            this.password.length < 10
                ? (this.errors.minLength.status = false)
                : (this.errors.minLength.status = true);
            !this.password.match(/[a-z]/)
                ? (this.errors.lowercase.status = false)
                : (this.errors.lowercase.status = true);
            !this.password.match(/[A-Z]/)
                ? (this.errors.uppercase.status = false)
                : (this.errors.uppercase.status = true);
            !this.password.match(/[0-9]/)
                ? (this.errors.number.status = false)
                : (this.errors.number.status = true);
            !this.password.match(/[@$!%*#?&^]/)
                ? (this.errors.character.status = false)
                : (this.errors.character.status = true);
            this.password != this.passwordConfirm
                ? (this.errors.match.status = false)
                : (this.errors.match.status = true);
        },
        activate(ref) {
            this.$refs[ref].removeAttribute("readonly");
        },
    },
    computed: {
        isValid() {
            let fails = _find(this.errors, {
                status: false,
            });
            return !fails;
        },
        formClass() {
            return parseInt(this.required) == 1
                ? "form-item input-text required"
                : "form-item input-text";
        },
    },
};
</script>

<style lang="scss" scoped></style>
